import * as React from 'react';
import {
  List,
  Datagrid,
  Filter,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  TextField,
  DateField,
  ReferenceField,
  ReferenceInput,
} from 'react-admin';

const useTxtData = {
  table: {
    id: 'id',
    S_xumu_id: '畜牧',
    yimiaoName: '疫苗名称',
    xumuType: '适用类型',
    days: '免疫日龄',
    jibie: '免疫级别',
    remark: '备注',
  }
};

export const S_xumu_yimiao_planList = (props) => (
  <List {...props} filters={<Filters />}>
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <TextField label={useTxtData.table.yimiaoName} source="yimiaoName" />
      <TextField label={useTxtData.table.xumuType} source="xumuType" />
      <TextField label={useTxtData.table.days} source="days" />
      <TextField label={useTxtData.table.jibie} source="jibie" />
      <TextField label={useTxtData.table.remark} source="remark" />
    </Datagrid>
  </List>
);

const Filters = (props) => (
  <Filter {...props}>
    <SelectInput label={useTxtData.table.xumuType} source="xumuType" choices={[
      { id: '猪', name: '猪' },
      { id: '牛', name: '牛' },
      { id: '羊', name: '羊' },
    ]} alwaysOn />
  </Filter>
);

export const S_xumu_yimiao_planEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput label={useTxtData.table.yimiaoName} source="yimiaoName" />
      <SelectInput label={useTxtData.table.xumuType} source="xumuType" choices={[
        { id: '猪', name: '猪' },
        { id: '牛', name: '牛' },
        { id: '羊', name: '羊' },
      ]} />
      <NumberInput label={useTxtData.table.days} source="days" />
      <SelectInput label={useTxtData.table.jibie} source="jibie" choices={[
        { id: '强制', name: '强制' },
        { id: '推荐', name: '推荐' },
        { id: '可选', name: '可选' },
      ]} />
      <TextInput label={useTxtData.table.remark} source="remark" multiline />
    </SimpleForm>
  </Edit>
);

export const S_xumu_yimiao_planCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput label={useTxtData.table.yimiaoName} source="yimiaoName" />
      <SelectInput label={useTxtData.table.xumuType} source="xumuType" choices={[
        { id: '猪', name: '猪' },
        { id: '牛', name: '牛' },
        { id: '羊', name: '羊' },
      ]} />
      <NumberInput label={useTxtData.table.days} source="days" />
      <SelectInput label={useTxtData.table.jibie} source="jibie" choices={[
        { id: '强制', name: '强制' },
        { id: '推荐', name: '推荐' },
        { id: '可选', name: '可选' },
      ]} />
      <TextInput label={useTxtData.table.remark} source="remark" multiline />
    </SimpleForm>
  </Create>
);